import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { StickyNote } from "lucide-react";
import axios from "axios";
import Navbar from "./Navbar";

const PatientSummaryNote = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [summary, setSummary] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const fetchSummary = async () => {
    const patient_id = location.state?.patient_id;
    if (!patient_id) return;

    try {
      const response = await axios.post(
        "https://lovencare.gopillz.com/api/summary",
        JSON.stringify({ patient_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setSummary(response.data.summary || "No summary available for this patient.");
      }
    } catch (error) {
      console.error("Error fetching summary:", error);
      setSummary("Failed to fetch summary. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100">
      <Navbar />

      {/* Main Container */}
      <div className="flex justify-center items-start px-4 sm:px-6 md:px-8 pt-28 pb-12">
        <div className="w-full max-w-3xl bg-white rounded-3xl shadow-xl border border-emerald-100 p-6 sm:p-10 transition-all">

          {/* Header */}
          <div className="flex items-center gap-4 mb-6">
            <div className="bg-emerald-100 p-3 rounded-full shadow-md">
              <StickyNote className="w-7 h-7 sm:w-9 sm:h-9 text-emerald-600" />
            </div>
            <h1 className="text-2xl sm:text-3xl font-semibold text-emerald-800">
              Patient Summary Note
            </h1>
          </div>

          {/* Summary Content */}
          {isLoading ? (
            <div className="text-center text-emerald-600 font-medium text-lg">
              Loading summary...
            </div>
          ) : (
            <div className="relative bg-gradient-to-br from-white/80 to-emerald-50/70 backdrop-blur-md text-gray-800 p-5 sm:p-7 rounded-2xl text-base sm:text-lg leading-relaxed whitespace-pre-line border border-emerald-200 shadow-md hover:shadow-lg transition-all duration-300">
              {summary}
            </div>
          )}

          {/* Back Button */}
          <div className="mt-8 text-center">
            <button
              onClick={() => navigate(-1)}
              className="w-full sm:w-auto bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700 text-white font-semibold px-6 py-3 rounded-full shadow-md hover:shadow-lg transition-transform transform hover:scale-105"
            >
              ← Back to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientSummaryNote;
